module.exports = __webpack_public_path__ + "img/DSC_1105.dc57d603.jpg";